import {PageLayout} from '@/layouts';

import {TrustAccountAccessBanner} from './TrustAccountAccessBanner';

import type {ComponentProps} from 'react';

type TrustAccountPageLayoutProps = ComponentProps<typeof PageLayout>;

/**
 * `PageLayout` for any page rendered inside a `TrustAccountProvider` — always renders the
 * role banner (self-hides when the caller needs none) above the rest of the content,
 * inside `PageLayout`'s own error-state gating so it disappears along with the real content
 * on error, same as before.
 */
export function TrustAccountPageLayout({children, ...props}: TrustAccountPageLayoutProps) {
  return (
    <PageLayout {...props}>
      <TrustAccountAccessBanner />
      {children}
    </PageLayout>
  );
}
